import React from 'react';
import {Col, Container, Row
} from 'reactstrap';
import moment from 'moment';
import TimeAgo from 'react-time-ago'
import InterpretStatus from "../utils/interpretor";
import ToolTipItem from "../utils/tooltip";

import IconMdDate from 'react-icons/lib/md/date-range';
import IconMdAirplanemodeActive from 'react-icons/lib/md/airplanemode-active';

const DashboardPendingRecord = ({report}) => {
    const identifier = report.Id;
    return (
        <div className={"timeline-box-w pending"}>
            <div className="timeline-time">
                    <span>
                        <TimeAgo>{ parseInt(moment(report.CreatedDate).format('x'), 0)}</TimeAgo>
                    </span>
            </div>
            <div className="timeline-box">
                <div className="timeline-info">
                    <p className="timeline-role">
                        <IconMdAirplanemodeActive size="18" color="#43a8df"/>  <strong>{report.Airline}</strong> uploaded a file via <strong>{ InterpretStatus.pullModes(report.PullMode) }</strong>
                    </p>
                    <div>
                        <Container>
                            <Row>
                                <Col sm="12">
                                    <footer style={{ paddingLeft: '20px'}} className="blockquote-footer pull-left">
                                        <IconMdDate size="18" color="#202021"/>
                                        &nbsp;<ToolTipItem key={identifier + 'createdDate'} title={moment((report.CreatedDate).split('T')[0]).format('MMM Do, YYYY')} content='Created Date ' id={ identifier + 'createdDate'}/>
                                        <span style={{paddingLeft: '25px'}}>&nbsp;</span>
                                    </footer>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardPendingRecord;



// WEBPACK FOOTER //
// ./src/views/dashboard/pending-record.js